import { CallDto } from '@act/shared/data-transfer-objects';
import { Box, Typography } from '@mui/material';
import { PhoneListIcon, ScrollIcon } from '@phosphor-icons/react';
import { ToastProvider } from 'react-components/app/ReusableToast';
import { TrackingProvider } from 'react-components/tracking';
import TabbedPanel, { TabDefinition } from 'toolkit/tabs/tabbedPanel';
import SummaryPane from './SummaryPane';
import TranscriptionPane from './TranscriptionPane';

interface ReviewPaneProps {
  voiceCall: CallDto;
}

const ReviewPane = ({ voiceCall }: ReviewPaneProps) => {
  const tabDefinitions: TabDefinition[] = [
    {
      key: 'summary',
      ddTrackingName: 'generated-notes',
      label: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ScrollIcon size={24} />
          <Typography variant="titleMedium">Generated notes</Typography>
        </Box>
      ),
      component: <SummaryPane voiceCallRecording={voiceCall?.recording} />,
    },
    {
      key: 'goals',
      ddTrackingName: 'transcript',
      label: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PhoneListIcon size={24} />
          <Typography variant="titleMedium">Transcript</Typography>
        </Box>
      ),
      component: (
        <TranscriptionPane voiceCallRecording={voiceCall?.recording} />
      ),
    },
  ];
  return (
    <TrackingProvider contextName="review-pane">
      <ToastProvider>
        <TabbedPanel
          tabDefinitions={tabDefinitions}
          fullWidth
          shouldEvenflow
          minimalIndicator
          hideBottomBorder
        />
      </ToastProvider>
    </TrackingProvider>
  );
};

export default ReviewPane;
